export default __webpack_public_path__ + "static/media/headphone_enabled.c21ce86f.svg";